import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    snackbar: {
      show: false,
      message: '',
      color: 'success',
    },

  }),
  actions: {
    triggerSnackbar({ message, color = 'success' }) {
      this.snackbar = { show: true, message, color };

      // autocierre
      setTimeout(() => {
        this.snackbar.show = false;
        this.snackbar.message = '';
      }, 5000);
    },
  },
});